export default __webpack_public_path__ + "static/media/disciplinewillofonslaught.eb28bdd3.png";